import {
  FileText,
  Import,
  Settings,
  User,
  Users,
  type LucideIcon,
} from "lucide-react";

import { ChangelogPage } from "../../misc/ChangelogPage";
import { ImportPage } from "../../misc/ImportPage";

export interface AccountMenuEntry {
  to: string;
  icon: LucideIcon;
  label: string;
  labelArgs?: Record<string, unknown>;
  /** Shown only when the user can access this resource/action. */
  access?: { resource: string; action: string };
}

/** Account menu of the sidebar user card (the old header user menu). */
export const ACCOUNT_MENU_ENTRIES: AccountMenuEntry[] = [
  { to: "/profile", icon: User, label: "crm.profile.title" },
  {
    to: "/sales",
    icon: Users,
    label: "resources.sales.name",
    labelArgs: { smart_count: 2 },
    access: { resource: "sales", action: "list" },
  },
  {
    to: "/settings",
    icon: Settings,
    label: "crm.settings.title",
    access: { resource: "configuration", action: "edit" },
  },
  { to: ImportPage.path, icon: Import, label: "crm.header.import_data" },
  { to: ChangelogPage.path, icon: FileText, label: "crm.changelog.title" },
];
